import CircleIcon from "@mui/icons-material/Circle";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  styled,
  Typography,
} from "@mui/material";
import React from "react";
import { primary } from "../../../constants/theme";

const CustomContent = styled(Box)(({ theme }) => ({
  margin: "48px auto 12px auto",

  ".content-container": {
    width: "84%",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    ".content-heading": {
      fontSize: "50px",
      fontWeight: "600",
    },
    ".content-subheading": {
      fontSize: "30px",
      color: primary.greyText,
      fontWeight: "600",
      marginBottom: "20px",
    },
    ".content-text": {
      fontSize: "16px",
      marginBottom: "5px",
      fontWeight: "400",
      color: primary.black,
    },
    ".listItem": {
      fontSize: "16px",
      fontWeight: "400",
      color: primary.black,
      listStyle: "circle",
    },
    ".list-head": {
      fontWeight: "600",
    },
    ".content-heading2": {
      fontSize: "24px",
      fontWeight: "600",
    },
    ".content-subheading2": {
      fontSize: "20px",
      fontWeight: "600",
      color: primary.greyText,
      marginBottom: "20px",
    },
  },

  [theme.breakpoints.down("md")]: {
    ".content-container": {
      width: "100%",
      padding: "0 15px",
      ".content-heading": {
        fontSize: "30px",
      },
      ".content-subheading": {
        fontSize: "20px",
      },
      ".content-text": {
        fontSize: "16px",
      },
      ".content-heading2": {
        fontSize: "24px",
      },
      ".content-subheading2": {
        fontSize: "20px",
      },
    },
  },

  [theme.breakpoints.down("sm")]: {
    padding: "4px",
    ".content-container": {
      width: "100%",
      padding: "0 15px",
      ".content-heading": {
        fontSize: "24px",
      },
      ".content-subheading": {
        fontSize: "16px",
        marginBottom: "20px",
      },
      ".content-text": {
        fontSize: "12px",
      },
      ".content-subheading2": {
        fontSize: "16px",
        marginBottom: "20px",
      },
      ".listItem": {
        fontSize: "14px",
        fontWeight: "400",
        color: primary.black,
        listStyle: "circle",
      },
      ".list-head": {
        fontWeight: "600",
      },
    },
  },
}));
const BulletPoints = ({ ContentData }) => {
  return (
    <CustomContent>
      <Box className="content-container">
        <Typography variant="h2" className="content-heading2">
          {ContentData?.heading}
        </Typography>
        <Typography variant="p" className="content-text">
          {ContentData?.subheading}
        </Typography>
        {ContentData?.heading2 && (
          <Typography variant="h2" className="content-heading2">
            {ContentData?.heading2}
          </Typography>
        )}
        {ContentData?.subheading2 && (
          <Typography variant="p" className="content-text">
            {ContentData?.subheading2}
          </Typography>
        )}
        <List
          sx={{ listStyle: "inside", listStylePosition: "inside" }}
        >
          {ContentData?.listItems?.map((item, index) => (
            <ListItem
              key={index}
              className="listItem"
              sx={{ listStyleType: "disc", listStylePosition: "inside" }}
            >
              <ListItemIcon style={{ color: primary.black }}>
                <CircleIcon style={{ width: "12px" }} />
              </ListItemIcon>
              <ListItemText>
                <Typography variant="p">
                  <Typography variant="span" className="list-head">
                    {item?.listHead}
                  </Typography>{" "}
                  {item?.listItemText}
                </Typography>
              </ListItemText>
            </ListItem>
          ))}
        </List>
        <Typography variant="p" className="content-text">
          {ContentData?.contentText}
        </Typography>
      </Box>
    </CustomContent>
  );
};

export default BulletPoints;
